/**
 * These are very rudimentary user agent detection methods.
 * They work well for the purposes we require them to, but they're not
 * very robust, so be careful when using them.
 */

export const isFirefox = navigator.userAgent.includes('Firefox');

export const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);

export const isMobile = isIOS || /Android/i.test(navigator.userAgent);

export const isSafariIOS =
  isIOS && /Safari\//i.test(navigator.userAgent) && !/Chrom|FxiOS|CriOS/i.test(navigator.userAgent);
